// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

export const PENSION_PLAN_DISPLAY_ASSET_TYPE = 'pension-plan';

const PENSION_PLAN_ASSET_TYPES = new Set([
  'pension-plan',
  'pension-plans',
  'eu_pension_plans',
  'us_pension_plans',
]);

const HOLDING_ASSET_TYPE_FORMATTER: Record<string, string> = {
  'mutual funds': 'fund',
  stocks: 'stock',
  mutual_fund: 'fund',
  equity: 'stock',
  funds: 'fund',
};

export const isPensionPlanAssetType = (assetType?: string | null): boolean => {
  if (!assetType) {
    return false;
  }

  return PENSION_PLAN_ASSET_TYPES.has(assetType);
};

export const formatHoldingAssetType = (assetType?: string | null): string => {
  if (!assetType) {
    return 'other';
  }

  return HOLDING_ASSET_TYPE_FORMATTER[assetType] ?? assetType;
};

export const resolveHoldingDisplayAssetType = ({
  holdingAssetType,
  classifierAssetType,
  enrichedAssetType,
}: {
  readonly holdingAssetType?: string | null;
  readonly classifierAssetType?: string | null;
  readonly enrichedAssetType?: string | null;
}): string => {
  if (
    isPensionPlanAssetType(holdingAssetType) ||
    isPensionPlanAssetType(classifierAssetType)
  ) {
    return PENSION_PLAN_DISPLAY_ASSET_TYPE;
  }

  return formatHoldingAssetType(enrichedAssetType ?? holdingAssetType);
};

export const isFundLikeHoldingAssetType = (assetType?: string | null): boolean => {
  return (
    assetType === 'fund' ||
    assetType === 'mutual_fund' ||
    assetType === PENSION_PLAN_DISPLAY_ASSET_TYPE
  );
};
